import React from 'react';
import classNames from 'classnames';
import './styles.scss';
import { Box } from '@towersystems/towersystems-design-system';
import Footer from './footer';
import Section from './section';
import Header from './header';

const Card = ({ header = '', shadow = true, body = '', footer = '', children = null, className, ...rest }) => {
    return (
        <Box className={classNames(['card', className, { shadow }])} {...rest}>
            {children}
        </Box>
    );
};

Card.Footer = Footer;
Card.Section = Section;
Card.Header = Header;

export default Card;
